(function() {
    angular
        .module("devicesModule")
        .controller("DeviceMessageBoardStoredMessagesController", DeviceMessageBoardStoredMessagesController)

    DeviceMessageBoardStoredMessagesController.$inject = [
        "$rootScope",
        "$scope",
        "$state",
        "$stateParams",
        "$timeout",
        "$uibModal",
        "prefs",
        "devicesService",
        "messageBoardsService",
        "messagesService",
        "messagePreviewService",
        "userMessagingService"
    ]

    function DeviceMessageBoardStoredMessagesController(
        $rootScope,
        $scope,
        $state,
        $stateParams,
        $timeout,
        $uibModal,
        prefs,
        devicesService,
        messageBoardsService,
        messagesService,
        messagePreviewService,
        userMessagingService
    ){

        /**
            $scope variables
         **/


        $scope.sort_by        = prefs.get().messageBoard.messages.sortBy
        $scope.sort_direction = prefs.get().messageBoard.messages.sortOrder
        $scope.perPage        = prefs.get().messageBoard.messages.perPage
        $scope.filter_by      = prefs.get().messageBoard.messages.showGroup

        if ($scope.sort_by === "favorite")   { $scope.sort_by_title = "Favorites"    } else
        if ($scope.sort_by === "created_at") { $scope.sort_by_title = "Date Created" } else { $scope.sort_by_title = "Message Name" }

        if ($scope.filter_by === "favorites") { $scope.filterTitle = "Favorite"   } else
        if ($scope.filter_by === "custom")    { $scope.filterTitle = "Custom"     } else
        if ($scope.filter_by === "permanent") { $scope.filterTitle = "Pre-Loaded" } else { $scope.filterTitle = "All" }

        $scope.page = 1
        $scope.messages = []
        $scope.selectedAll = false
        $scope.hasOtherMessageBoards = false

        let gotMessages = false

        const updateDisplay = () => {

            if (gotMessages) {

                let timezone_iana = undefined

                if ($scope.messageBoard.hasOwnProperty("device")) {
                    timezone_iana = $scope.messageBoard.device.timezone_iana
                }

                for (const message of $scope.messages) {
                    message.createdAtDisplay = $rootScope.presentDateTime(message.created_at, "NumericShortDate", timezone_iana)
                }
            }
        }

        $scope.isMessageModifiable = (message_name) => {
            if (typeof message_name === "string" || message_name instanceof String) {
                return message_name.indexOf("C") === 0
            }
            return false
        }

        const readyToGenerate = [false, false]

        const generatePreviews = async () => {

            if (readyToGenerate.indexOf(false) === -1) {

                for (const message of $scope.messages) {
                    if (message.hasOwnProperty("multi")) {
                        $scope.previewController = await messagePreviewService.getController($scope.messageBoard)
                        messagePreviewService.generatePreviewFromMulti($scope.previewController, message.multi, "previewContainer-" + message.id)
                    }
                }
            }
        }

        const getAllMessages = () => {

            devicesService.getDevices((categorized) => {

                $scope.hasOtherMessageBoards = categorized.messageBoards.length > 1

                let _filterBy = $scope.filter_by === "all" ? "" : $scope.filter_by

                messageBoardsService.getMessageBoardMessages($stateParams.message_board_id, $scope.page, $scope.perPage, $scope.sort_by, $scope.sort_direction, _filterBy, async (data) => {

                    $scope.messages = data
                    gotMessages = true
                    updateDisplay()

                    if (readyToGenerate.indexOf(false) >= 0) {
                        readyToGenerate[readyToGenerate.indexOf(false)] = true
                    }

                    $timeout(async () => await generatePreviews())

                    $scope.max = messageBoardsService.getTotalMessageBoardMessages()
                    getPageCount()
                })
            })
        }
        getAllMessages()

        $scope.sortMessageBoardMessages = (sortBy, sortByTitle, sortDirection, filterBy) => {
            let _filterBy = filterBy === "all" ? "" : filterBy
            messageBoardsService.getMessageBoardMessages($stateParams.message_board_id, 1, $scope.perPage, sortBy, sortDirection, _filterBy, async (data) => {

                $scope.messages = data
                updateDisplay()
                await generatePreviews()

                $scope.page = 1
                $scope.filter_by = filterBy
                $scope.sort_by = sortBy
                $scope.sort_by_title = sortByTitle
                $scope.sort_direction = sortDirection

                $scope.max = messageBoardsService.getTotalMessageBoardMessages()
                getPageCount()

                prefs.set(prefs.selectors().messageBoard.messages.sortBy, sortBy, prefs.selectors().messageBoard.messages.sortOrder, sortDirection, prefs.selectors().messageBoard.messages.showGroup, filterBy)

            })
        }

        /**
            Activate message
            @param messageID
         **/
        $scope.activateMessage = (messageID, messageName) => {
            $scope.messageBoard.in_process = true
            messagesService.activateMessage(
                $stateParams.message_board_id,
                messageID,
                () => {
                    //Success
                    gtag("event", "display_change", { action: "complete", device_id: $scope.messageBoard.device.id, slot_name: messageName })
                    userMessagingService.success("Message Activation Request Sent")
                },
                (error) => {
                    //Failure
                    $scope.messageBoard.in_process = false
                    userMessagingService.error(error)
                }
            )
        }

        /**
            Open Delete Message modal
            @param {int}    messageID
            @param {string} messageName
         **/
        $scope.openDeleteMessageModal = (messageID, messageName) => {

            messagesService.getAssociatedEvents(
                $stateParams.message_board_id,
                messageID,
                (data) => {
                    //Success
                    let hasAssociatedEvents = false
                    if (data.hasOwnProperty("associated_events") && Object.prototype.toString.call(data.associated_events) === "[object Array]" && data.associated_events.length > 0) {
                        hasAssociatedEvents = true
                    }
                    $uibModal.open({
                        templateUrl: "app/modals/delete-message-modal.view.html",
                        controller: "DeleteMessageModalController",
                        resolve: {
                            messageBoardID: () => {
                                return $stateParams.message_board_id
                            },
                            messageID: () => {
                                return messageID
                            },
                            messageName: () => {
                                return messageName
                            },
                            hasAssociatedEvents: () => {
                                return hasAssociatedEvents
                            }
                        }
                    }).result.then(() => {
                        $scope.messageBoard.in_process = true
                    }).catch((res) => {
                        if (!(res === "cancel" || res === "escape key press")) {
                            throw res
                        }
                    })
                },
                (error) => {
                    //Failure
                    userMessagingService.error("Unable to delete message. Internal error when checking for associated scheduled events. If this error persists, please contact Wanco Support for assistance.")
                }
            )
        }

        /**
            Refresh messages
            @param messageType
         **/
        $scope.refreshMessages = (messageType) => {
            // $scope.isRefreshingMessages = true
            $scope.messageBoard.in_process = true
            const success = () => {
                userMessagingService.success("Refresh Messages Request Sent: This may take a few minutes.")
            }

            const failure = (error) => {
                // $scope.isRefreshingMessages = false
                $scope.messageBoard.in_process = false
                userMessagingService.error(error)
            }

            messageBoardsService.refreshMessageBoardMessages($stateParams.message_board_id, messageType, success, failure)
        }

        /**
            Favorite message
            @param messageID
         **/
        $scope.favoriteMessage = (messageID) => {

            const success = () => {
                getAllMessages()
            }

            const failure = (error) => {
                userMessagingService.error(error)
            }

            messageBoardsService.favoriteMessageBoardMessage($stateParams.message_board_id, messageID, success, failure)
        }

        /**
            Unfavorite message
            @param messageID
         **/
        $scope.unfavoriteMessage = (messageID) => {

            const success = () => {
                getAllMessages()
            }

            const failure = (error) => {
                userMessagingService.error(error)
            }

            messageBoardsService.unfavoriteMessageBoardMessage($stateParams.message_board_id, messageID, success, failure)
        }

        /**
            Select all messages
         **/
        $scope.checkAll = () => {
            angular.element(document).find(".message-checkbox").prop("checked", $scope.selectedAll)
        }

        /**
            Uncheck select all
         **/
        $scope.uncheckSelectedAll = () => {
            $scope.selectedAll = false
        }

        // const getSelectedMessages = () => {
        //     const checkboxes = angular.element(document).find(".message-checkbox:checked")
        //     const message_ids = []

        //     for (const checkbox of checkboxes) {
        //         message_ids.push($(checkbox).data("message-id"))
        //     }

        //     return message_ids
        // }

        /**
            Clone message
            @param messageID
         **/
        $scope.cloneMessage = (messageID) => {
            const messageIDs = []
            messageIDs.push(messageID)

            const messageBoardIDs = []
            messageBoardIDs.push($stateParams.message_board_id)

            // const messageIDs = getSelectedMessages()
            messagesService.cloneMessageToDevice(
                $stateParams.message_board_id,
                messageIDs,
                messageBoardIDs,
                () => {
                    //Success
                    userMessagingService.success("Message Clone Request Sent")
                },
                (error) => {
                    //Failure
                    userMessagingService.error(error)
                }
            )
        }

        /**
            Clone modal
            @param messageID
         **/
        $scope.cloneModal = (messageID) => {
            const messageIDs = []
            messageIDs.push(messageID)

            $uibModal.open({
                templateUrl: "app/modals/clone-to-devices.view.html",
                controller: "CloneToDevicesModalController",
                resolve: {
                    messageIDs: () => {
                        return messageIDs
                    }
                }
            }).result.catch((res) => {
                if (!(res === "cancel" || res === "escape key press")) {
                    throw res
                }
            })
        }

        /**
            Message pagination config
            @param perPage
         **/
        $scope.changePerPage = (perPage) => {
            $scope.perPage = perPage
            $scope.page = 1
            getPageCount()
            $scope.getData()
        }

        $scope.changePage = (page) => {
            const newPage = $scope.page + page

            if(newPage < 1 || newPage > $scope.maxPages) {
                return
            }

            $scope.page = newPage
            $scope.getData()
        }

        $scope.getData = () => {

            const _filterBy = $scope.filter_by === "all" ? "" : $scope.filter_by

            messageBoardsService.getMessageBoardMessages($stateParams.message_board_id, $scope.page, $scope.perPage, $scope.sort_by, $scope.sort_direction, _filterBy, async (data) => {
                $scope.messages = data
                updateDisplay()
                await generatePreviews()
            })
        }


        const getPageCount = () => {
            $scope.maxPages = Math.ceil($scope.max / $scope.perPage)
        }

        $scope.$watch("retrievedMessageBoard", async (retrievedMessageBoard) => {

            if (retrievedMessageBoard) {

                updateDisplay()

                if (readyToGenerate.indexOf(false) >= 0) {
                    readyToGenerate[readyToGenerate.indexOf(false)] = true
                }

                await generatePreviews()

            }
        })

        $scope.$watch("$root.pushedData", (pushedData) => {

            if (pushedData.deviceID > 0 && $scope.messageBoard.hasOwnProperty("device")) {

                if (pushedData.deviceID === $scope.messageBoard.device.id) {

                    if (pushedData.reload || (pushedData.commandType === "refresh_messages" && pushedData.inProcess === false)) {
                        getAllMessages()
                    }

                }
            }
        })
    }
})()
